import {AxiosError} from 'axios';
import {toast} from 'react-toastify';

interface ErrorResponse {
  type_error?: 'publicModal' | 'publicToastify';
  message?: string;
}

export class AppRequestError extends Error {
  error: AxiosError<ErrorResponse>;
  constructor(error: AxiosError<ErrorResponse>) {
    super();
    this.name = 'appRequestError';
    this.error = error;
    this.initilizeError();
  }

  private initilizeError() {
    if (
      this.error?.response &&
      this.error?.response?.data &&
      this.error?.response?.data?.type_error &&
      this.error?.response?.data?.type_error in typeOfShowError
    ) {
      typeOfShowError[this.error?.response?.data?.type_error](
        this.error?.response?.data?.message,
      );
    }
    return this.error;
  }
}
export class BadRequest extends AppRequestError {
  constructor(error: AxiosError<ErrorResponse>) {
    super(error);
  }
}
export class Unauthorized extends AppRequestError {
  constructor(error: AxiosError<ErrorResponse>) {
    super(error);
    this.navigateToLogin();
  }

  navigateToLogin() {
    window.localStorage.clear();
    window.location.href = '/steps';
  }
}
export class PaymentRequired extends AppRequestError {
  constructor(error: AxiosError<ErrorResponse>) {
    super(error);
  }
}
export class Forbidden extends AppRequestError {
  constructor(error: AxiosError<ErrorResponse>) {
    super(error);
  }
}
export class NotFound extends AppRequestError {
  constructor(error: AxiosError<ErrorResponse>) {
    super(error);
  }
}
export class MethodNotAllowed extends AppRequestError {
  constructor(error: AxiosError<ErrorResponse>) {
    super(error);
  }
}
export class NotAcceptable extends AppRequestError {
  constructor(error: AxiosError<ErrorResponse>) {
    super(error);
  }
}
export class ProxyAuthenticationRequired extends AppRequestError {
  constructor(error: AxiosError<ErrorResponse>) {
    super(error);
  }
}
export class RequestTimeout extends AppRequestError {
  constructor(error: AxiosError<ErrorResponse>) {
    super(error);
  }
}
export class Conflict extends AppRequestError {
  constructor(error: AxiosError<ErrorResponse>) {
    super(error);
  }
}
export class Gone extends AppRequestError {
  constructor(error: AxiosError<ErrorResponse>) {
    super(error);
  }
}
export class LengthRequired extends AppRequestError {
  constructor(error: AxiosError<ErrorResponse>) {
    super(error);
  }
}
export class PreconditionFailed extends AppRequestError {
  constructor(error: AxiosError<ErrorResponse>) {
    super(error);
  }
}
export class PayloadTooLarge extends AppRequestError {
  constructor(error: AxiosError<ErrorResponse>) {
    super(error);
  }
}
export class UnsupportedMediaType extends AppRequestError {
  constructor(error: AxiosError<ErrorResponse>) {
    super(error);
  }
}
export class UnprocessableContent extends AppRequestError {
  constructor(error: AxiosError<ErrorResponse>) {
    super(error);
  }
}
export class Locked extends AppRequestError {
  constructor(error: AxiosError<ErrorResponse>) {
    super(error);
  }
}
export class FailedDependency extends AppRequestError {
  constructor(error: AxiosError<ErrorResponse>) {
    super(error);
  }
}
export class UpgradeRequired extends AppRequestError {
  constructor(error: AxiosError<ErrorResponse>) {
    super(error);
  }
}
export class PreconditionRequired extends AppRequestError {
  constructor(error: AxiosError<ErrorResponse>) {
    super(error);
  }
}
export class TooManyRequests extends AppRequestError {
  constructor(error: AxiosError<ErrorResponse>) {
    super(error);
  }
}

export class UnexpectedRequestError extends Error {
  constructor() {
    super('خطایی رخ داده است!');
    this.name = 'unexpectedError';
  }
  formatErrorsIntoReadableStr() {
    toast.error(
      'خطایی از سمت سرور رخ داده است لطفا در زمان دیگری مراجعه فرمایید',
    );
  }
}

export const UserStatusError: Record<
  number,
  (error: AxiosError<ErrorResponse>) => void
> = {
  400: (error: AxiosError<ErrorResponse>) => new BadRequest(error),
  401: (error: AxiosError<ErrorResponse>) => new Unauthorized(error),
  402: (error: AxiosError<ErrorResponse>) => new PaymentRequired(error),
  403: (error: AxiosError<ErrorResponse>) => new Forbidden(error),
  404: (error: AxiosError<ErrorResponse>) => new NotFound(error),
  405: (error: AxiosError<ErrorResponse>) => new MethodNotAllowed(error),
  406: (error: AxiosError<ErrorResponse>) => new NotAcceptable(error),
  407: (error: AxiosError<ErrorResponse>) =>
    new ProxyAuthenticationRequired(error),
  408: (error: AxiosError<ErrorResponse>) => new RequestTimeout(error),
  409: (error: AxiosError<ErrorResponse>) => new Conflict(error),
  410: (error: AxiosError<ErrorResponse>) => new Gone(error),
  411: (error: AxiosError<ErrorResponse>) => new LengthRequired(error),
  412: (error: AxiosError<ErrorResponse>) => new PreconditionFailed(error),
  413: (error: AxiosError<ErrorResponse>) => new PayloadTooLarge(error),
  415: (error: AxiosError<ErrorResponse>) => new UnsupportedMediaType(error),
  416: (error: AxiosError<ErrorResponse>) => new AppRequestError(error),
  417: (error: AxiosError<ErrorResponse>) => new AppRequestError(error),
  422: (error: AxiosError<ErrorResponse>) => new UnprocessableContent(error),
  423: (error: AxiosError<ErrorResponse>) => new Locked(error),
  424: (error: AxiosError<ErrorResponse>) => new FailedDependency(error),
  426: (error: AxiosError<ErrorResponse>) => new UpgradeRequired(error),
  428: (error: AxiosError<ErrorResponse>) => new PreconditionRequired(error),
  429: (error: AxiosError<ErrorResponse>) => new TooManyRequests(error),
};
const typeOfShowError: Record<string, (dataString?: string) => void> = {
  public_modal: (dataString?: string) => {
    toast.error(dataString || 'modalError');
  },
  public_toastify: (dataString?: string) => {
    toast.error(
      dataString || 'خطایی رخ داده است لطفا در زمان دیگری مراجعه بفرمایید!',
    );
  },
};
